import controller from './cif-share-modal';
import template from './cif-share-modal.pug';

class CifShareService {
  /* @ngInject */
  constructor($uibModal) {
    this.$uibModal = $uibModal;
  }

  open(caseId, caseData) {
    return this
      .$uibModal
      .open({
        size: 'md',
        animation: true,
        template,
        controller,
        controllerAs: '$ctrl',
        resolve: {
          caseId: () => caseId,
          caseData: () => caseData,
        },
      })
      .result;
  }
}

export default CifShareService;



// WEBPACK FOOTER //
// ./client/components/cif-share/cif-share-modal.service.js